<template>
    <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2>



        <v-flex xs12 sm12 md8 ml-0 mt-1>
            <v-flex v-html="errorContent"></v-flex>
            <v-flex  xs12 sm12 md12 fontMiddle regTitle style="text-align: center">

                {{formatRocDate(this.$route.query.viewDate)}}
                {{transApn(this.$route.query.apn)}}
                {{this.$route.query.divName}} {{this.$route.query.clinicName}} {{this.$route.query.doctorName}}
                <!--大安婦幼 掛號 初複診畫面-->
                <!--{{regInfo}}-->
            </v-flex>

            <v-flex :style="{textAlign:$vuetify.breakpoint.smAndDown?'left':'left'}" mt-2>
                <span class="regBodyFont">請輸入</span>
                <span class="regBodyFont2">[身分證號]</span>
                <span class="regBodyFont">或</span>
                <span class="regBodyFont2"> [居留證號碼]</span>
                <span class="regBodyFont">，進行網路掛號</span>
            </v-flex>


            <!--初複診-->
            <v-container>
                <v-row>

                    <v-col cols="12" sm="12" md="8" style="text-align: right">
                        <v-col cols="12" sm="12" md="12" >
                            <span  class="regLabel">身分證號*</span>
                            <v-text-field
                                    :disabled="checkAgree==false"
                                    style="display: inline-block;"
                                    class="regInput"
                                    hide-details
                                    label="身分證號"
                                    clearable
                                    solo
                            ></v-text-field>
                        </v-col>



                        <v-col cols="12" sm="12" md="12" style="text-align: right">
                            <span  class="regLabel ">初診電話/手機號碼*</span>
                            <v-text-field
                                    :style="{display:'inline-block',minWidth:$vuetify.breakpoint.smAndDown?'195px':'auto',width:$vuetify.breakpoint.smAndDown?'195px':'auto',maxWidth:$vuetify.breakpoint.smAndDown?'195px':'auto'}"
                                    :disabled="checkAgree==false"
                                    class="regInput"
                                    hide-details
                                    label="電話"
                                    clearable
                                    solo
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="text-align: right">
                            <span class="regLabel ">初診病患姓名*</span>
                            <v-text-field
                                    :style="{display:'inline-block',minWidth:$vuetify.breakpoint.smAndDown?'235px':'auto',width:$vuetify.breakpoint.smAndDown?'235px':'auto',maxWidth:$vuetify.breakpoint.smAndDown?'235px':'auto'}"
                                    :disabled="checkAgree==false"
                                    class="regInput"
                                    hide-details
                                    label="姓名"
                                    clearable
                                    solo
                            ></v-text-field>
                        </v-col>


                    </v-col>

                    <!--<v-col cols="12" sm="12" md="4">-->

                    <!--</v-col>-->






                </v-row>
            </v-container>





            <v-divider></v-divider>

          <!-- 2025/08/29 馨蕙馨獨家修改 By Mars -->
            <!-- <v-container style="padding: 0px">
                目前預計預約看診號碼為      <span class="nowViewNo">{{regInfo.viewNo}}</span>
            </v-container> -->

            <v-flex :style="{textAlign:$vuetify.breakpoint.smAndDown?'center':'right'}" mt-2>
                <v-btn   middle class="pl-1 pr-1 mr-2 " :disabled="checkAgree==false">
                    預約掛號
                </v-btn>
                <v-btn  middle class="pr-1 pl-1 mr-2" :disabled="checkAgree==false">
                    重新輸入
                </v-btn>
                <v-btn  middle class="pr-1 pl-1 " :disabled="checkAgree==false">
                    確定為初診
                </v-btn>
            </v-flex>

            <personal-permission :disabled="!firstCheck" :zone-name="zoneName" @agree="agree"></personal-permission>

        </v-flex>

        <v-flex class="xs12 sm12 md4 pl-1 mt-1">

            <p v-html="regNote"></p>
        </v-flex>


        <v-dialog v-model="errorDialog"
                  persistent
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <alert-win @closeDialog="closeErrorDialog" @confirm="errConfirm" :alery-type="aleryType"  :alert-title="errorTitle" :alert-msg="errorContent" ></alert-win>
        </v-dialog>


        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

    </v-flex>
</template>

<script>
    import PersonalPermission from './PersonalPermission'
    import AlertWin from '../inursingsys/AlertWin'
    export default {
        name: "RegDaan",
        components:{PersonalPermission,AlertWin},
        data() {
            return {
                snTimeout:4000,
                snStatus:false,
                snText:'',
                regInfo:{},
                zoneName:'',
                checkAgree:false,
                regNote:'',
                firstCheck:false,
                errorDialog:false,
                errorTitle: '',
                errorContent:'',
                aleryType:'error',
            }
        },
        mounted: function() {
            if (this.$route.query.viewDate){
                let viewDate = this.$route.query.viewDate;
                let apn = this.$route.query.apn;
                let doctorNo = this.$route.query.doctorNo;
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let clinicNo = this.$route.query.clinicNo;
                this.axios_getRegClinic(viewDate,apn,doctorNo,zone,clinicNo);
                this.axios_getRegNote(this.$route.query.divNo+","+this.$route.query.clinicNo+","+this.$route.query.doctorNo)
            }
        },
        methods:{
            closeErrorDialog(){
                this.errorDialog = false;
            },

            errConfirm(){
                this.closeErrorDialog();
            },
            agree(agree){
                this.checkAgree = agree;
            },
            transApn(apn){
                if(apn.toString()=="1"){
                    return "早上";
                }else if(apn.toString()=='2') {
                    return "下午";
                }else {
                    return "晚上";
                }
            },
            formatRocDate(viewDate){
                let yyy = viewDate.substring(0,3);
                let mm = viewDate.substring(3,5);
                let dd = viewDate.substring(5,7);
                return yyy+"年"+mm+"月"+dd+"日";
            },
            axios_getRegClinic(viewDate,apn,doctorNo,zone,clinicNo){ //查詢掛號 第一階段檢查
                this.errorContent = '';
                this.firstCheck = false;
                this.regNote = '';
                let url = this.$store.state.AppSetting.backSrvUrl+'webregistration/precheck/'+viewDate+"/"+apn+"/"+doctorNo+"/"+zone+"/"+clinicNo;


                this.$http.get(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        this.regInfo = response.data.resultSet[0];
                        this.zoneName = this.regInfo.zoneName;
                        this.firstCheck = true;
                    }else {
                        this.zoneName = '';
                        this.firstCheck = false;
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.errorContent = '<div style="color: red">'+ response.data.message+'</div>';
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    this.zoneName = '';
                    this.firstCheck = false;
                    try {
                        switch (error.response.status){
                            case 300:
                            case 400:
                            case 401:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent = '<div style="color: red;font-size: 1.2rem;font-weight: bold">'+ error.response.data.message+'</div>';
                                break;
                            case 404:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent ="找不到頁面";
                                break;
                            case 500:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent = "伺服器錯誤";
                                break;
                            default:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent ='<div style="color: red;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
                        }

                    } catch(err) {
                        console.log(err.response.data.message)
                    }
                });
            },
            axios_getRegNote (codeNo){ //掛號說明
                let url = '';
                this.regNote = "";
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/REG/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.regNote = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regNote = '';
                    } catch(err) {
                        this.regNote = '';
                    }
                });


            },
        }
    }
</script>

<style scoped>

    .regTitle{
        background: #C8E3FF;
        color: #1D2088;
        font-weight: bold;
        border: 1px solid #BAA7AA;
        padding: 10px;
    }

    .regBodyFont{
        color: #23AAE9;
        font-size: 1.2rem;
    }

    .regBodyFont2{
        color: #FF6868;
        font-size: 1.2rem;
    }

    .regInput{
        min-height: auto!important;
    }

    .regLabel{
        margin-top: 12px!important;
        margin-right: 5px;
    }

    .nowViewNo{
        color: #FF6666;
        font-weight: bold;
        font-size: 2rem;
    }

</style>